import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../store/rootReducer';
import { closeSubscriptionModal } from '../../../store/subscription/subscriptionSlice';
import { NO_SEARCH_TOKENS_KEY } from '../../../utils/constants';

export function RefillTokenModal() {
    const { activeModal, modalProps } = useSelector((state: IAllStates) => state.subscription);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isRefillModalActive = activeModal === 'refill';
    const closeModalAction = () => {
        dispatch(closeSubscriptionModal());
    };
    const noSearchTokens = modalProps?.source === NO_SEARCH_TOKENS_KEY;

    return (
        <Modal
            onHide={closeModalAction}
            show={isRefillModalActive}
            aria-labelledby="contained-modal-title-vcenter"
            centered={true}
        >
            <Modal.Body className="p-4">
                <div className="text-center my-4">
                    <div>
                        <img width={130} src="/icons/profile/trolley.svg" className="mb-3" alt="Icon placeholder" />
                    </div>
                    <h5 className="mb-3">
                        {noSearchTokens
                            ? t(`general.stripe.refill_search_tokens`)
                            : t(`general.stripe.refill_profile_tokens`)}
                    </h5>
                    <p>
                        {noSearchTokens
                            ? t(`general.stripe.refill_search_tokens_desc`)
                            : t(`general.stripe.refill_profile_tokens_desc`)}
                    </p>
                    <Button className="mx-2" variant="outline-primary" onClick={() => closeModalAction()}>
                        {t('general.button.close')}
                    </Button>
                    <Button onClick={() => (window.location.href = String(process.env.VITE_REFILL_TOKEN_CALENDLY))}>
                        {t('general.button.contact/support')}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}
